import posthog from "posthog-js";
import { isIntentionalUserError } from "./error-tracking-config";

/** Error boundaries swallow errors before autocapture sees them; report explicitly. */
export function reportCaughtError(error: unknown, boundary: string): void {
  if (!posthog.__loaded || isIntentionalUserError(error)) return;
  posthog.captureException(error, { boundary });
}
